import { readContract } from '@wagmi/core';
import abi from '../abi';

export async function getUserSmartContractWallets(
	walletAddress: string,
	SC_WALLET_ACCOUNT_RESOLVER: `0x${string}`
): Promise<string[]> {
	const txData = (await readContract({
		address: SC_WALLET_ACCOUNT_RESOLVER,
		abi: abi.scWalletAccountResolver,
		functionName: 'getAuthorityAccounts',
		args: [walletAddress]
	})) as Array<string>;
	return txData;
}

export async function getSmartContractWalletOwners(
	overrideSmartContractWalletAddress: string,
	SC_WALLET_ACCOUNT_RESOLVER: `0x${string}`
): Promise<string[]> {
	const txData = await readContract({
		address: SC_WALLET_ACCOUNT_RESOLVER,
		abi: abi.scWalletAccountResolver,
		functionName: 'getAccountAuthorities',
		args: [overrideSmartContractWalletAddress]
	});
	return txData as Array<string>;
}
